import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../src/app/environments/environment';
import { Socio } from '../models/sociosRequest.model';
import { SocioRequest } from '../models/interfaces/socioRequest.interface';
import { SocioResponse } from '../models/socioResponse.model';
import { AtualizarProLaboreSocioRequest, ProLaboreSocioEdicaoResponse } from '../models/proLaboreSocio.model';

@Injectable({
  providedIn: 'root',
})
export class SociosService {
  private apiUrl = `${environment.advContabilApi}/api`;

  constructor(private http: HttpClient) { }

  saveSocio(socio: SocioRequest): Observable<SocioRequest> {
    return this.http.post<SocioRequest>(`${this.apiUrl}/ESocial/EnviarEventoS2300`, socio, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  saveSocioBd(socioRequest: Socio): Observable<any> {
    return this.http.post(`${this.apiUrl}/ESocial/Inserir/InserirCliente`, {
      dto: socioRequest
    }).pipe(
      catchError(error => {
        console.error('Erro ao salvar sócio:', error);
        return throwError(() => error);
      })
    );
  }

  obterProximaMatricula(usuarioId: string): Observable<{ proximaMatricula: number }> {
    return this.http.get<{ proximaMatricula: number }>(`${this.apiUrl}/ESocial/ObterProximaMatricula/ObterProximaMatricula?usuarioId=${usuarioId}`).pipe(
      catchError(error => {
        console.error('Erro ao obter próxima matrícula:', error);
        return throwError(() => error);
      })
    );
  }

  listarSocios(usuarioId: string): Observable<SocioResponse[]> {
    const url = `${this.apiUrl}/ESocial/ListarPorUsuario/ListarPorUsuario`;
    
    return this.http.get<SocioResponse[]>(url, {
      params: { usuarioId }
    }).pipe(
      catchError((error) => {
        console.error('Erro na chamada HTTP:', error);
        console.error('URL que falhou:', url);
        console.error('Status:', error.status);
        console.error('StatusText:', error.statusText);
        return throwError(() => error);
      })
    );
  }

  calcularProLabore(valorProLabore: number, numeroDependentes: number): Observable<{ inss: number, irrf: number, valorLiquido: number }> {
    const request = { ValorProLabore: valorProLabore, NumeroDependentes: numeroDependentes };
    return this.http.post<{ inss: number, irrf: number, valorLiquido: number }>(`${this.apiUrl}/ESocial/CalcularProLabore/CalcularProLabore`, request, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }).pipe(
      catchError(this.handleError)
    );
  }

  obterProLaboreSocio(socioId: number, competenciaMes: number, competenciaAno: number): Observable<ProLaboreSocioEdicaoResponse> {
    return this.http.get<ProLaboreSocioEdicaoResponse>(`${this.apiUrl}/ESocial/ObterProLaboreSocio/ObterProLaboreSocio`, {
      params: {
        socioId,
        competenciaMes,
        competenciaAno
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  atualizarProLaboreSocio(request: AtualizarProLaboreSocioRequest): Observable<ProLaboreSocioEdicaoResponse> {
    return this.http.put<ProLaboreSocioEdicaoResponse>(`${this.apiUrl}/ESocial/AtualizarProLaboreSocio/AtualizarProLaboreSocio`, request, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<never> {
    let errorMessage = 'Ocorreu um erro inesperado.';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Erro: ${error.error.message}`;
    } else {
      errorMessage = `Código de erro: ${error.status}, Mensagem: ${error.message}`;
    }
    return throwError(() => new Error(errorMessage));
  }
}

